const CONTACTS_SEARCH_PROFILES_ROOT_PATH = "/sales-api/leads-generator/v2/profiles";

export const PROFILE_ID_PLACEHOLDER = "{profileId}";

export const ContactsSearchProfilesEndpoint = {
    GET_ALL: CONTACTS_SEARCH_PROFILES_ROOT_PATH,
    CREATE: CONTACTS_SEARCH_PROFILES_ROOT_PATH,
    UPDATE: `${CONTACTS_SEARCH_PROFILES_ROOT_PATH}/${PROFILE_ID_PLACEHOLDER}`,
    DELETE: `${CONTACTS_SEARCH_PROFILES_ROOT_PATH}/${PROFILE_ID_PLACEHOLDER}`,
    EXCLUDE: `${CONTACTS_SEARCH_PROFILES_ROOT_PATH}/${PROFILE_ID_PLACEHOLDER}/exclude`,
};
